import help from '../../_scripts/helpers';

'use strict';

export default class OrdersControls {
	constructor(params) {
		this.root = document.querySelector(params.rootSelector);
	}

	init() {
		if (!this.root) return false;

		this.filter = this.root.querySelector('[data-orders-filter]');
		this.filterContainer = this.root.querySelector('[data-orders-filter-container]');
		this.forms = [...this.root.querySelectorAll('form')];
		this.selects = [...this.root.querySelectorAll('[data-filter-select]')];
		this.inputs = [...this.root.querySelectorAll('[data-filter-input]')];
		this.ordersContainer = document.querySelector('[data-orders-container]');
		this.filterModal = document.querySelector('[data-filter-modal]');
		this.submitBtn = this.root.querySelector('[data-filter-submit-btn]');
		this.resetBtns = [...this.root.querySelectorAll('[data-filter-reset-btn]')];

		this.dirty = false;
		this.refreshContent = true;

		this._formsHandler();
		this._selectsHandler();
		this._inputsHandler();
		this._modalFilter();
		this._submitBtnHandler();
		this._checkFormDirty();
		this._resetBtnsHandler();
	}

	_formsHandler() {
		if (!this.forms.length) return false;

		this.forms.forEach(form => {
			form.addEventListener('submit', e => {
				e.preventDefault();

				let url = window.location.href + '?',
					data = {};

				url = url.substr(0, url.indexOf('?'));

				this.selects.forEach(select => {
					[...select.options].forEach(option => {
						if (option.selected && !option.disabled) {
							// data.push(`${option.dataset.name}=${option.value}`);
							data[option.dataset.name] = option.value;
						}
					});
				});

				this.inputs.forEach(input => {
					if (!input.disabled && input.value) {
						// data.push(`${input.dataset.name}=${input.value}`);
						data[input.dataset.name] = input.value;
					}
				})


				$.ajax({
					// url: url+'?ajax=y&'+data.join('&'),
					url: form.action,
					data: data,
					method: 'GET',
					dataType: 'json',
					beforeSend: () => {
						console.log(this.mobile);
						if (this.refreshContent) {
							if (!this.mobile) {
								this.ordersContainer.classList.add('is-loading');
							} else {
								//form.classList.add('is-loading');
							}
						} else {
							//form.classList.add('is-loading');
						}
					},
					success: res => {
						history.pushState(null, null, res.URL);

						if (this.refreshContent || true) {
							$(this.ordersContainer).replaceWith($(res.CONTENT).find('#ajax_order_list').html());

							if (!this.mobile) {
								this.ordersContainer.classList.remove('is-loading');
							} else {
								form.classList.remove('is-loading');
							}

							if ($.modal.getCurrent()) {
								$.modal.getCurrent().close();
							}
						} else {
							form.classList.remove('is-loading');
						}

						this.ordersContainer = document.querySelector('[data-orders-container]');


						for (let i in res.ITEMS) {
							let vals = res.ITEMS[i].VALUES;

							for (let j in vals) {

								let elem = vals[j],
									select = form.querySelector(`[name=${res.ITEMS[i].CODE}]`);

								if (select) {

									let option = select.querySelector(`option[data-name=${elem.CONTROL_ID}]`);

									if (elem.DISABLED) {
										option.disabled = true;
									} else {
										option.disabled = false;
									}

									select.sumo.reload();
								}
							}
						}
					}
				});
			})
		})
	}

	_triggerSubmit(form, refreshContent = true) {
		if (!form) return false;

		this.refreshContent = refreshContent;

		form.dispatchEvent(new Event('submit'));
	}

	_selectsHandler() {
		if (!this.selects.length) return false;

		this.selects.forEach(select => {
			$(select).on('change', e => {
				this._triggerSubmit(select.closest('form'), false);
				this._checkFormDirty();
			})
		})
	}

	_inputsHandler() {
		if (!this.inputs.length) return false;
		let self = this;

		this.inputs.forEach(input => {
			// $(input).on('input', help.debounce(e => {
			// 	this._triggerSubmit(input.closest('form'));
			// }, 500));
			$(input).on('input', e => {
				this._checkFormDirty();
			})
		})
	}

	_modalFilter() {
		if (!this.filterModal) return false;

		let mql = window.matchMedia('(min-width: 768px)'),
			screenTest = e => {
				if (e.matches) {
					$(this.filter).appendTo(this.filterContainer);
					this.mobile = false;
				} else {
					$(this.filter).appendTo(this.filterModal);
					this.mobile = true;
				}
			};

		screenTest(mql);
		mql.addListener(screenTest);
	}

	_submitBtnHandler() {
		if (!this.submitBtn) return false;

		this.submitBtn.addEventListener('click', e => {
			e.preventDefault();
			this._triggerSubmit(this.submitBtn.closest('form'));
		})
	}

	_resetBtnsHandler() {
		if (!this.resetBtns.length) return false;

		this.resetBtns.forEach(btn => {
			btn.addEventListener('click', e => {
				e.preventDefault();
				[this.inputs, this.selects].forEach(elements => {
					elements.forEach(element => {
						element.value = "";
						if (element.tagName === 'SELECT') {
							element.sumo.reload();
						};
					})
				});
				this.dirty = false;
				this._resetBtnsVisibility();
				this._triggerSubmit(btn.closest('form'));
			})
		})
	}

	_checkFormDirty() {
		let inputsEmpty = this.inputs.every(input => input.value == ''),
			selectsEmpty = this.selects.every(select => $(select).val() == '');

		if (!inputsEmpty || !selectsEmpty) {
			this.dirty = true;
		} else {
			this.dirty = false;
		}

		this._resetBtnsVisibility();
	}

	_resetBtnsVisibility() {
		if (!this.resetBtns.length) return false;

		this.resetBtns.forEach(btn => {
			if (this.dirty) {
				btn.classList.remove('is-hidden');
			} else {
				btn.classList.add('is-hidden');
			}
		});
	}
}
